var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerDetalhes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ver_detalhes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home_Pesquisa",
    transform: "translate(-1038.000000, -5509.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "item_stock_1-copy-14",
    transform: "translate(972.000000, 5013.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42-Copy",
    transform: "translate(67.100000, 495.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ver_detalhes",
    transform: "translate(7.333333, 8.000000) rotate(-270.000000) translate(-7.333333, -8.000000) translate(1.833333, 0.666667)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -4.65789474,
    y1: 4.65789474,
    x2: 5.34210526,
    y2: 4.65789474,
    id: "Vector",
    transform: "translate(0.342105, 5.000000) rotate(-90.000000) translate(-0.342105, -5.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4.65789474,
    x2: 10.5,
    y2: 4.65789474,
    id: "Vector",
    transform: "translate(5.500000, 5.000000) rotate(-90.000000) translate(-5.500000, -5.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.65789474,
    y1: 4.65789474,
    x2: 15.6578947,
    y2: 4.65789474,
    id: "Vector",
    transform: "translate(10.657895, 5.000000) rotate(-90.000000) translate(-10.657895, -5.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.0120614035,
    y1: 13.9703947,
    x2: 0.69627193,
    y2: 13.9703947,
    id: "Vector",
    transform: "translate(0.342105, 14.312500) rotate(-90.000000) translate(-0.342105, -14.312500) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.14583333,
    y1: 13.9703947,
    x2: 5.85416667,
    y2: 13.9703947,
    id: "Vector",
    transform: "translate(5.500000, 14.312500) rotate(-90.000000) translate(-5.500000, -14.312500) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.3037281,
    y1: 13.9703947,
    x2: 11.0120614,
    y2: 13.9703947,
    id: "Vector",
    transform: "translate(10.657895, 14.312500) rotate(-90.000000) translate(-10.657895, -14.312500) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerDetalhes);
export default __webpack_public_path__ + "static/media/ver_detalhes.371a26e8873ef475f3b39e186d5e177e.svg";
export { ForwardRef as ReactComponent };